import Vue from 'vue';
import img from './index.vue';

const imgPreview = Vue.extend(img);


const handleClick = (options, binding, el) => {
  return (evt) => {
    el.imgPreview.vm.$nextTick(() => {
      setTimeout(() => {
        el.imgPreview.vm.open();
      }, 0);
    });
  };
};

const doUpdate = (options, binding, el) => {
  el.imgPreview.vm.list = binding.value;
};

export default {
  install(Vue, options) {
    Vue.directive('image-preview', {
      bind(el, binding, vnode, oldVnode) {
        el.imgPreview = new imgPreview();
        el.imgPreview.vm = el.imgPreview.$mount();
        document.body.appendChild(el.imgPreview.vm.$el);
        el.imgPreview.vm.list = binding.value;
        console.log(binding.value, /v/);
        el.addEventListener('click', handleClick(options, binding, el));
      },
      update(el, binding, vnode) {
        doUpdate(options, binding, el);
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/directive/img-preview/index.js